import { render, staticRenderFns } from "./DetailUserCompanyPage.vue?vue&type=template&id=fef6297a&"
import script from "./DetailUserCompanyPage.vue?vue&type=script&lang=js&"
export * from "./DetailUserCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fef6297a')) {
      api.createRecord('fef6297a', component.options)
    } else {
      api.reload('fef6297a', component.options)
    }
    module.hot.accept("./DetailUserCompanyPage.vue?vue&type=template&id=fef6297a&", function () {
      api.rerender('fef6297a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/DetailUserCompanyPage.vue"
export default component.exports